import Popover from "../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../gd-components/gd-popover/popover-position"
import React from "react"
import ProjectSession from "../../../model2/project/project-session"
import {findDOMNode} from "react-dom"
import MoreProject_PopoverMenu from "./popover-menu"
import {PopoverAttachmentType} from "../../../gd-components/gd-popover/@const";

type Props = {
    hidePopover              : callback
    project                  : ProjectSession
    parent                   : any // must have hide popover
    attachment?              : string
    targetAttachment?        : string
    targetOffset?            : string
    attachmentType?          : PopoverAttachmentType
    showPinStar?             : boolean
    outsideClickIgnoreClass? : string
}

// const debug = "MoreProject_Popover"
const debug = false

export default function MoreProject_Popover(props:Props) {

    const popoverPosition = new PopoverPosition({
        attachment      : !!props.attachment ? props.attachment : "top center",
        targetAttachment: !!props.targetAttachment ? props.targetAttachment : "bottom center",
        targetOffset    : !!props.targetOffset ? props.targetOffset : "0 0",
        attachmentType  : !!props.attachmentType ? props.attachmentType : PopoverAttachmentType.HORIZONTAL,
    })

    return (
        <Popover popoverClass               = "project-more-popover"
                 className                  = "project-more-popover-container"
                 position                   = {popoverPosition}
                 outsideClickIgnoreClass    = {props.outsideClickIgnoreClass}
                 getTargetFunc              = {()=>findDOMNode(props.parent)}
                 onClickOutside             = {props.hidePopover}>

            <MoreProject_PopoverMenu parent         = {props.parent}
                                     project        = {props.project}
                                     hidePopover    = {props.hidePopover}/>

        </Popover>
    )
}
